import React from "react";

import { Radio } from "./radio";

interface RadioGroupProps<T> {
  options: {
    label: string | React.ReactNode;
    value: T;
    disabled?: boolean;
    disabledTooltip?: string;
  }[];
  onChange: (value: T) => void;
  value: T;
  className?: string;
}

export const RadioGroup = <T extends string>({
  options,
  onChange,
  value,
  className,
}: RadioGroupProps<T>) => {
  return (
    <div className={className}>
      {options.map((option) => (
        <Radio<T>
          isDisabled={option.disabled}
          key={option.value}
          label={option.label}
          value={option.value}
          checked={value === option.value}
          onChange={onChange}
          disabledTooltip={option.disabledTooltip}
        />
      ))}
    </div>
  );
};
